import { Grid, Typography } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { AppState, store } from 'src/common/redux/configure-store';
import { resetCardWaiting } from 'src/devices/payment/get-card-details';
import { disablePayments } from 'src/devices/payment/pinpad-operations';
import { getCurrentXLRConfig } from 'src/xlr-configuration/xlr-config';
import barcode from '../media/barcode.svg';
import { styles } from './item-list-styles';

const EmptyCart: React.FC = (): JSX.Element => {
  const classes = styles();
  const returnMode = useSelector((state: AppState) => !!state.posMode.returnMode.returnType);
  const { t } = useTranslation();

  const isTransactionActive = useSelector(
    (state: AppState): boolean => !!state.transaction.transactionIdExists,
  );

  useEffect((): void => {
    async function disablePaymentsOnNoSale() {
      if (!isTransactionActive) {
        if (store.getState().pinPad.isPinpadConfigured) {
          await disablePayments();
          resetCardWaiting();
        }
      }
    }

    const { shouldCallCardIdentificationNotExpected } = getCurrentXLRConfig();
    if (shouldCallCardIdentificationNotExpected) {
      disablePaymentsOnNoSale();
    }
  }, [isTransactionActive]);

  return (
    <Grid
      container
      direction='column'
      className={`fullHeight ${classes.emptyCartContainer}`}
      data-testid={`item-list-empty`}
    >
      <Grid item>
        <Typography variant='h4'>
          {returnMode ? t('Empty_Cart_Return_Mode') : t('Empty_Cart_No_Sale')}
        </Typography>
      </Grid>
      <Grid item>
        <Grid container justifyContent='center' className={classes.emptyCartBarcode}>
          <Grid item>
            <img src={barcode} alt='Barcode' className={classes.icon} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default EmptyCart;
